/* eslint-disable camelcase */
import { PudoLocation } from '@pperform/pp-data-mappers';
import APIError from 'exceptions/APIError';
import { ErrorCodes } from 'constants/errors.constants';
import AppError from 'exceptions/AppError';
import { getPudoLocationsFetcher } from '../fetchers/pudoLocation.fetcher';

interface DropOffLocations {
  locations: PudoLocation[];
}

export const searchDropOffLocations = async (
  orgSlug: string,
  orgId: number,
  values: { postalCode: string; countryCode: string; carrierId: string },
): Promise<DropOffLocations> => {
  try {
    const { data: collectionPoints } = await getPudoLocationsFetcher(orgId, {
      organization_slug: orgSlug,
      postal_code: values.postalCode,
      country_code: values.countryCode,
      carrier_id: values.carrierId,
    });

    const locations: PudoLocation[] = collectionPoints
      .map((dto): PudoLocation => PudoLocation.fromApiData(dto))
      .sort((obj1: PudoLocation, obj2: PudoLocation) =>
        (obj1.address?.addressName || '').localeCompare(
          obj2.address?.addressName || '',
        ),
      );

    return { locations };
  } catch (error) {
    if (error instanceof APIError) {
      throw new AppError(error.message);
    }

    throw error;
  }
};
